// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FakeSelect.PointerCursor {
  cursor: pointer;
}
.FakeSelect h5 {
  display: flex;
  align-items: center;
  color: var(--gray_dark2);
  font-size: 14px;
}
.FakeSelect h5 span {
  margin-right: 4px;
  color: var(--gray);
}
.FakeSelect h5 .select-icon {
  margin-left: 0.3em;
  height: 0.6em;
  width: 0.6em;
}`, "",{"version":3,"sources":["webpack://./src/components/FakeSelect/index.scss"],"names":[],"mappings":"AACE;EACE,eAAA;AAAJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;AAAJ;AACI;EACE,iBAAA;EACA,kBAAA;AACN;AACI;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AACN","sourcesContent":[".FakeSelect {\n  &.PointerCursor {\n    cursor: pointer;\n  }\n  h5 {\n    display: flex;\n    align-items: center;\n    color: var(--gray_dark2);\n    font-size: 14px;\n    span {\n      margin-right: 4px;\n      color: var(--gray);\n    }\n    .select-icon {\n      margin-left: 0.3em;\n      height: 0.6em;\n      width: 0.6em;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
